import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { SignInPage } from "../components/SignInPage";
import { SignUpPage } from "../components/SignUpPage";

/** Auth routes — full-screen, composed directly under the root (outside the shell). */
export function createAuthRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({ getParentRoute: () => parent, path: "/sign-in", component: SignInPage }),
    createRoute({ getParentRoute: () => parent, path: "/sign-up", component: SignUpPage }),
  ];
}
